/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetAodRulesByIdQueryResponse, AuditReportsGetAodRulesByIdPathParams, AuditReportsGetAodRulesByIdQueryParams, AuditReportsGetAodRulesById401, AuditReportsGetAodRulesById403 } from "../models/AuditReportsGetAodRulesById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetAodRulesById } from "../axios/auditReportsGetAodRulesById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetAodRulesByIdQueryKey = (id: AuditReportsGetAodRulesByIdPathParams["id"], params: AuditReportsGetAodRulesByIdQueryParams = {}) => ["api-v2", { url: '/audit-reports/v1/aod-rules/:id', params: {id:id} }, ...(params ? [params] : [])] as const

export type AuditReportsGetAodRulesByIdQueryKey = ReturnType<typeof auditReportsGetAodRulesByIdQueryKey>

export function auditReportsGetAodRulesByIdQueryOptions(id: AuditReportsGetAodRulesByIdPathParams["id"], params?: AuditReportsGetAodRulesByIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetAodRulesByIdQueryKey(id, params)
        return queryOptions<AuditReportsGetAodRulesByIdQueryResponse, ResponseErrorConfig<AuditReportsGetAodRulesById401 | AuditReportsGetAodRulesById403>, AuditReportsGetAodRulesByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetAodRulesById(id, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve a single AodRule
 * {@link /audit-reports/v1/aod-rules/:id}
 */
export function useAuditReportsGetAodRulesById<TData = AuditReportsGetAodRulesByIdQueryResponse, TQueryData = AuditReportsGetAodRulesByIdQueryResponse, TQueryKey extends QueryKey = AuditReportsGetAodRulesByIdQueryKey>(id: AuditReportsGetAodRulesByIdPathParams["id"], params?: AuditReportsGetAodRulesByIdQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetAodRulesByIdQueryResponse, ResponseErrorConfig<AuditReportsGetAodRulesById401 | AuditReportsGetAodRulesById403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetAodRulesByIdQueryKey(id, params)
         

         const query = useQuery({
          ...auditReportsGetAodRulesByIdQueryOptions(id, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetAodRulesById401 | AuditReportsGetAodRulesById403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}